<template>
  <section class="Footer">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2>Art Transplant</h2>
          <p>Complete service packages for galleries and collectors including art hanging, sculpture installation, gallery track exhibition systems, mirror installation, art security systems and framing consultation</p>
        </div>
        <div class="column">
          <h3>Services</h3>
          <ul>
            <li>Picture hanging systems</li>
            <li>Custom Art Display Solutions</li>
            <li>Sculpture Installation</li>
            <li>Art Security Installation</li>
            <li>Framing Consultation</li>
            <li>Reclaimed Materials Fabrication</li>
          </ul>
        </div>
        <div class="column">
          <h3>Quick Links</h3>
          <NavLinks />
        </div>
        <div class="column">
          <h3>Latest Work</h3>
            <vue-instagram token="10608144320.1677ed0.2188cfbc638f42df9900a6a0d859e6ee" :count="1" class="columns is-multiline is-mobile">
                <template slot="feeds" slot-scope="props">
                <div class="column">
                    <a :href="'//instagram.com/' + props.feed.user.username" target="_blank">
                        <figure class="image is-square">
                            <img :src="props.feed.images.standard_resolution.url" alt="Image">
                        </figure>
                    </a>
                </div>
                </template>
            </vue-instagram>
        </div>
      </div>
    </div>
    <Copyright />
  </section>
</template>
<script>
import NavLinks from '../components/NavLinks';
import Copyright from '../components/Copyright';
export default {
  name: 'Footer',
  components: {
    NavLinks,
    Copyright
  },
  computed: {
  },
  mounted () {
  },
  data () {
    return {
    };
  }
};
</script>
<style lang='scss' scoped>
@import '../scss/colors.scss';

  .Footer {
    background: $darkGrey;
    font-size: 0.8em;
    color: $white;

    .container {
        padding: 30px 20px;
        @media screen and (min-width: 768px) {
            padding: 75px 0;    
        }
    }
    
    h2 {
      color: $white;
      margin: 0 0 15px;
      text-align: left;
    }

    h3 {
      margin: 0.25em 0 0.5em;
    }

    ul li, .NavLinks li {
        list-style-type: none;
        border-bottom: 1px solid $white;
        margin: 0;
    }
  }
</style>
